export default "{\n    \"label\": \"Rol\"\n}\n"